import { faShuffle } from "@fortawesome/pro-regular-svg-icons/faShuffle";
import { faArrowsToLine } from "@fortawesome/pro-regular-svg-icons/faArrowsToLine";
import { faArrowsLeftRight } from "@fortawesome/pro-regular-svg-icons/faArrowsLeftRight";
import { faSmile } from "@fortawesome/pro-regular-svg-icons/faSmile";
import { faUmbrellaBeach } from "@fortawesome/pro-regular-svg-icons/faUmbrellaBeach";
import { faSuitcase } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faHeart } from "@fortawesome/pro-regular-svg-icons/faHeart";
import { faChartLineUp } from "@fortawesome/pro-regular-svg-icons/faChartLineUp";
import { faGraduationCap } from "@fortawesome/pro-regular-svg-icons/faGraduationCap";
import { faBullhorn } from "@fortawesome/pro-regular-svg-icons/faBullhorn";
export var ModificationNameEnum;
(function (ModificationNameEnum) {
    ModificationNameEnum["Custom"] = "Custom";
    ModificationNameEnum["Rephrase"] = "Rephrase";
    ModificationNameEnum["Shorten"] = "Shorten";
    ModificationNameEnum["Elaborate"] = "Elaborate";
    ModificationNameEnum["Friendly"] = "Friendly";
    ModificationNameEnum["Fun"] = "Fun";
    ModificationNameEnum["Professional"] = "Professional";
    ModificationNameEnum["Caring"] = "Caring";
    ModificationNameEnum["Inspirational"] = "Inspirational";
    ModificationNameEnum["Educational"] = "Educational";
    ModificationNameEnum["Persuasive"] = "Persuasive";
})(ModificationNameEnum || (ModificationNameEnum = {}));
export const modificationInstructions = {
    [ModificationNameEnum.Rephrase]: "Rephrase the text for improved clarity and readability.",
    [ModificationNameEnum.Shorten]: "Shorten the text while maintaining it's meaning.",
    [ModificationNameEnum.Elaborate]: "Elaborate on the idea by adding more details and context.",
    [ModificationNameEnum.Friendly]: "Adjust the tone of the text to be friendly and welcoming.",
    [ModificationNameEnum.Fun]: "Adjust the tone of the text to be fun and light-hearted.",
    [ModificationNameEnum.Professional]: "Adjust the tone of the text to be formal and professional.",
    [ModificationNameEnum.Caring]: "Adjust the tone of the the text to be compassionate and caring.",
    [ModificationNameEnum.Inspirational]: "Adjust the tone of the text to inspire the reader with motivational and uplifting language.",
    [ModificationNameEnum.Educational]: "Adjust the tone of the text to be informative and educational.",
    [ModificationNameEnum.Persuasive]: "Adjust the tone of the text to be persuasive and convincing."
};
export const intentExplanations = {
    "Heading": "This implies that the text should be clear and concise.",
    "Sub-heading": "This implies that the text should be more detailed.",
    "Narration": "This implies that the text will be narrated as part of a video scene.",
    "Footnote": "This implies that the text should be supplementary information or reference.",
    "Bullet": "This implies that the text should be a concise, standalone point in a list.",
    "Button": "This implies that the text should be a clear, actionable label for a button.",
    "CTA Button": "This implies that the text should be an engaging call-to-action for a button."
};
export const mainMenuList = [
    {
        icon: faShuffle,
        text: "Rephrase",
        action: ModificationNameEnum.Rephrase
    },
    {
        icon: faArrowsToLine,
        text: "Shorten",
        action: ModificationNameEnum.Shorten
    },
    {
        icon: faArrowsLeftRight,
        text: "Elaborate",
        action: ModificationNameEnum.Elaborate
    }
];
export const submenuList = [
    {
        icon: faSmile,
        text: "Friendly",
        action: ModificationNameEnum.Friendly
    },
    {
        icon: faUmbrellaBeach,
        text: "Fun",
        action: ModificationNameEnum.Fun
    },
    {
        icon: faSuitcase,
        text: "Professional",
        action: ModificationNameEnum.Professional
    },
    {
        icon: faHeart,
        text: "Caring",
        action: ModificationNameEnum.Caring
    },
    {
        icon: faChartLineUp,
        text: "Inspirational",
        action: ModificationNameEnum.Inspirational
    },
    {
        icon: faGraduationCap,
        text: "Educational",
        action: ModificationNameEnum.Educational
    },
    {
        icon: faBullhorn,
        text: "Persuasive",
        action: ModificationNameEnum.Persuasive
    }
];
//# sourceMappingURL=AiTextEditingUtils.js.map